import bootbox from 'bootbox'

$('body').on('click', '.grid-remove', function () {

  let id = $(this).data('id')
  let name = $(this).data('name')
  let hash = $(this).data('hash')
  let url = Routing.generate(`api_remove_${name}`, { id: id })

  bootbox.confirm({
    message: Translator.trans('form.confirm'),
    buttons: {
      confirm: {
        label: Translator.trans('common.yes'),
      },
      cancel: {
        label: Translator.trans('common.no'),
      }
    },
    callback: function (result) {
      if (result) {
        $.ajax({
          url: url,
          type: 'DELETE',
          success: function () {
            window.toastr.success(Translator.trans('form.removed'))
            eval(`${hash}_submitForm(event,$('#${hash}_search'))`)

          },
          error: function (xhr) {
            switch (xhr.status) {
              case 423:
                window.toastr.error(xhr.responseJSON.error)
                break
              case 424:
                window.toastr.error(Translator.trans(xhr.responseJSON.message))
                break
              case 425:
                window.toastr.error(xhr.responseJSON.message)
                break
              default:
                window.toastr.error(Translator.trans('form.errors.removed'))
            }
          }
        })
      }
    }
  })
})

$('body').on('click', '.massActionConfirmDelete', function () {
  let gridSelector = $(this).attr('data-grid-selector')
  bootbox.confirm({
    message: Translator.trans('form.action'),
    buttons: {
      confirm: {
        label: Translator.trans('common.yes'),
      },
      cancel: {
        label: Translator.trans('common.no'),
      }
    },
    callback: function (result) {
      bootbox.hideAll()
      if (result) {
        $(gridSelector).submit()
      }
    }
  })
})
